import { type LanguageCode } from 'common_packages/assets/js/types/locale'
import { klubbleAPI } from './common'

export const getAll = async (language: LanguageCode, abortController: AbortController) => {
  try {
    const res = await klubbleAPI.get(`languagetext/getalltexts?lang=${language}`, { signal: abortController?.signal })
    if (res.status === 200) {
      return res.data
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error fetching translations:', e)
  }
  return {}
}
